import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Media, { mediaTypeIsValid } from '../../../components/Media';
import InvertingColorsBlock from '../../../components/InvertingColorsBlock';
import { inject, observer } from 'mobx-react';

const Styled = styled.div`
  position: relative;
  overflow: hidden;
  padding-top: 100%;
  width: calc(100% + 2px);
  left: -1px;
  background-color: ${props => (props.hexColor ? props.hexColor : '#fff')};
`;

const StyledMedia = styled(Media)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  background: transparent;
  transform: scale(1.05);
`;

const Intro = ({ media, autoPlay, hex, isDarkTheme, themeStore, animationRunning }) => {
  if (!media.type || !mediaTypeIsValid(media.type)) {
    return null;
  }

  const shouldInvert =
    ((themeStore.isDark && !isDarkTheme) || (!themeStore.isDark && isDarkTheme)) && !animationRunning;

  return (
    <InvertingColorsBlock shouldInvert={shouldInvert} name={'INTRO'}>
      <Styled hexColor={hex}>
        <StyledMedia {...media} autoPlay={autoPlay} />
      </Styled>
    </InvertingColorsBlock>
  );
};

Intro.propTypes = {
  media: PropTypes.object,
  autoPlay: PropTypes.bool,
  themeStore: PropTypes.object.isRequired,
  isDarkTheme: PropTypes.bool,
  hex: PropTypes.string,
};

export default inject(stores => ({ themeStore: stores.store.theme }))(observer(Intro));



// WEBPACK FOOTER //
// ./src/scenes/Case/components/Intro.js